import { useState, useEffect } from 'react';

function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);

        const handler = (event) => setMatches(event.matches);

        // Совместимость с разными браузерами
        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener('change', handler);
        } else {
            mediaQueryList.addListener(handler);
        }

        // Установка изначального значения
        setMatches(mediaQueryList.matches);

        return () => {
            if (mediaQueryList.removeEventListener) {
                mediaQueryList.removeEventListener('change', handler);
            } else {
                mediaQueryList.removeListener(handler);
            }
        };
    }, [query]);

    return matches;
}

export default useMediaQuery;


export function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined'
            ? window.matchMedia(`(max-width: ${breakpoint}px)`).matches
            : false
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

        const handleChange = (e) => {
            setIsMobile(e.matches);
        };

        mediaQuery.addEventListener('change', handleChange);

        // Cleanup
        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, [breakpoint]);

    return isMobile;
}